import _flatten from 'lodash/flatten';
import _isEmpty from 'lodash/isEmpty';
import _pick from 'lodash/pick';
import { validateRequiredField } from '../DynamicFormFields/DynamicFormFields.utils';
export function validateFormField(field, value) {
  return validateRequiredField(field, value);
}
var targetFileObjectFields = ['uuid', 'isImage', 'name', 'size', 'mimeType', 'isSuccess'];
export function createFileObjects(files) {
  if (_isEmpty(files)) {
    return [];
  }
  return _flatten(files.map(function (file) {
    return _pick(file, targetFileObjectFields);
  }));
}